import { replaceContentElementWithPages } from './utils';

/**
 * 將 .content 元素的子節點切分成多頁
 */
const splitContentIntoPages = (nodes, pageSize, measureContainer, lineHeight, imgSizeCount, imgSizeActualHeight) => {
  // 先過濾掉空的或內容很少的節點
  const filteredNodes = nodes.filter(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent.trim().length > 0;
    }
    
    if (node.nodeType === Node.ELEMENT_NODE) {
      const hasParagraphClass = node.classList && node.classList.contains('paragraph');
      if (hasParagraphClass) {
        const testDiv = document.createElement('div');
        testDiv.className = 'content';
        testDiv.appendChild(node.cloneNode(true));
        measureContainer.innerHTML = testDiv.outerHTML;
        const nodeHeight = measureContainer.offsetHeight;
        const minHeight = lineHeight * 0.5;
        if (nodeHeight < minHeight) {
          return false;
        }
      }
      
      const hasTextContent = node.textContent && node.textContent.trim().length > 0;
      const hasChildElements = node.children && node.children.length > 0;
      
      return hasTextContent || hasChildElements;
    }
    
    return true;
  });
  
  const pages = [];
  let currentPageNodes = [];
  const maxHeight = pageSize * lineHeight;
  const firstPageMaxHeight = imgSizeCount > 0 ? maxHeight - imgSizeActualHeight : maxHeight;
  const isFirstPage = () => pages.length === 0;
  
  const hasClass = (node, className) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    return node.classList && node.classList.contains(className);
  };
  
  const cloneNodeForMeasurement = (node) => {
    const cloned = node.cloneNode(true);
    if (hasClass(cloned, 'ans_box')) {
      const imgBox = cloned.querySelector('.imgBox');
      if (imgBox) {
        imgBox.remove();
      }
    }
    return cloned;
  };
  
  filteredNodes.forEach((node, nodeIndex) => {
    const singleNodeDiv = document.createElement('div');
    singleNodeDiv.className = 'content';
    singleNodeDiv.appendChild(cloneNodeForMeasurement(node));
    
    // 修改：使用 setHTMLAndApplyBrStyles 方法
    if (measureContainer.setHTMLAndApplyBrStyles) {
      measureContainer.setHTMLAndApplyBrStyles(singleNodeDiv.outerHTML);
    } else {
      measureContainer.innerHTML = singleNodeDiv.outerHTML;
      // 手動應用 br 樣式
      const brElements = measureContainer.querySelectorAll('br');
      brElements.forEach(br => {
        br.style.display = 'none';
      });
    }
    
    // 強制瀏覽器重排
    void measureContainer.offsetWidth;
    const singleNodeHeight = measureContainer.offsetHeight;

    const testNodes = [...currentPageNodes.map(n => cloneNodeForMeasurement(n)), cloneNodeForMeasurement(node)];
    const testDiv = document.createElement('div');
    testDiv.className = 'content';
    testNodes.forEach(n => testDiv.appendChild(n.cloneNode(true)));
    
    // 修改：使用 setHTMLAndApplyBrStyles 方法
    if (measureContainer.setHTMLAndApplyBrStyles) {
      measureContainer.setHTMLAndApplyBrStyles(testDiv.outerHTML);
    } else {
      measureContainer.innerHTML = testDiv.outerHTML;
      const brElements = measureContainer.querySelectorAll('br');
      brElements.forEach(br => {
        br.style.display = 'none';
      });
    }
    
    void measureContainer.offsetWidth;
    const testHeight = measureContainer.offsetHeight;
    
    let currentPageHeight = 0;
    if (currentPageNodes.length > 0) {
      const currentPageDiv = document.createElement('div');
      currentPageDiv.className = 'content';
      currentPageNodes.forEach(n => currentPageDiv.appendChild(cloneNodeForMeasurement(n)));
      
      // 修改：使用 setHTMLAndApplyBrStyles 方法
      if (measureContainer.setHTMLAndApplyBrStyles) {
        measureContainer.setHTMLAndApplyBrStyles(currentPageDiv.outerHTML);
      } else {
        measureContainer.innerHTML = currentPageDiv.outerHTML;
        const brElements = measureContainer.querySelectorAll('br');
        brElements.forEach(br => {
          br.style.display = 'none';
        });
      }
      
      // 強制瀏覽器重排
      void measureContainer.offsetWidth;
      currentPageHeight = measureContainer.offsetHeight;
    }
    
    const currentPageMaxHeight = isFirstPage() ? firstPageMaxHeight : maxHeight;
    const currentPageLineCount = currentPageNodes.length;
    const newPageLineCount = currentPageLineCount + 1;
    
    const tolerance = Math.max(currentPageMaxHeight * 0.1, 1);
    const availableLines = isFirstPage() ? (pageSize - imgSizeCount) : pageSize;
    const singleNodeExceedsLimit = singleNodeHeight > currentPageMaxHeight;
    const shouldSplitByLines = newPageLineCount > availableLines && currentPageNodes.length > 0;
    const shouldSplitByHeight = (testHeight >= (currentPageMaxHeight - tolerance) && currentPageNodes.length > 0) || singleNodeExceedsLimit;
    
    if (shouldSplitByHeight || shouldSplitByLines) {
      const isCurrentAnsBox = hasClass(node, 'ans_box');
      const lastNode = currentPageNodes.length > 0 ? currentPageNodes[currentPageNodes.length - 1] : null;
      const isLastSubject = lastNode && hasClass(lastNode, 'subject');
      
      if (isCurrentAnsBox && isLastSubject && currentPageNodes.length > 0) {
        const subjectNode = currentPageNodes.pop();
        
        // 先保存當前頁面的其他內容（如果有）
        if (currentPageNodes.length > 0) {
          const pageDiv = document.createElement('div');
          pageDiv.className = 'content';
          currentPageNodes.forEach(n => pageDiv.appendChild(n.cloneNode(true)));
          pages.push(pageDiv.innerHTML);
        }
        
        // 測量 subject 的高度
        const subjectDiv = document.createElement('div');
        subjectDiv.className = 'content';
        subjectDiv.appendChild(cloneNodeForMeasurement(subjectNode));
        
        // 修改：使用 setHTMLAndApplyBrStyles 方法
        if (measureContainer.setHTMLAndApplyBrStyles) {
          measureContainer.setHTMLAndApplyBrStyles(subjectDiv.outerHTML);
        } else {
          measureContainer.innerHTML = subjectDiv.outerHTML;
          const brElements = measureContainer.querySelectorAll('br');
          brElements.forEach(br => {
            br.style.display = 'none';
          });
        }
        
        // 強制瀏覽器重排
        void measureContainer.offsetWidth;
        const subjectHeight = measureContainer.offsetHeight;
        
        // 測量 ans_box 的完整高度
        const ansBoxDiv = document.createElement('div');
        ansBoxDiv.className = 'content';
        ansBoxDiv.appendChild(node.cloneNode(true));
        
        // 修改：使用 setHTMLAndApplyBrStyles 方法
        if (measureContainer.setHTMLAndApplyBrStyles) {
          measureContainer.setHTMLAndApplyBrStyles(ansBoxDiv.outerHTML);
        } else {
          measureContainer.innerHTML = ansBoxDiv.outerHTML;
          const brElements = measureContainer.querySelectorAll('br');
          brElements.forEach(br => {
            br.style.display = 'none';
          });
        }
        
        // 強制瀏覽器重排
        void measureContainer.offsetWidth;
        const ansBoxHeight = measureContainer.offsetHeight;
        
        // 計算總高度和可用高度
        const totalHeight = subjectHeight + ansBoxHeight;
        const availableHeight = currentPageMaxHeight - subjectHeight;
        const tolerance = Math.max(currentPageMaxHeight * 0.1, 1);
        
        // 判斷是否超過限制（超過 7 行）
        const exceedsLimit = totalHeight > currentPageMaxHeight + tolerance;
        
        if (exceedsLimit) {
          // 超過限制：將完整的 ans_box 移到新的一頁
          // 第一頁：只有 subject
          const firstPageDiv = document.createElement('div');
          firstPageDiv.className = 'content';
          firstPageDiv.appendChild(subjectNode.cloneNode(true));
          pages.push(firstPageDiv.innerHTML);
          
          // 檢查 ans_box 本身是否超過 7 行
          const ansBoxMaxHeight = maxHeight; // 第二頁的完整高度限制
          const ansBoxTolerance = Math.max(ansBoxMaxHeight * 0.1, 1);
          const ansBoxExceedsLimit = ansBoxHeight > ansBoxMaxHeight + ansBoxTolerance;
          
          if (ansBoxExceedsLimit) {
            // ans_box 超過 7 行：需要將內容分頁
            // 收集 ans_box 內部的節點，以 .ans 為單位（每個 .ans 代表一行）
            const collectAnsBoxContentNodes = (ansBoxElement) => {
              const nodes = [];
              
              // 只收集 .eol 內的內容（如果有的話）
              const eolElement = ansBoxElement.querySelector('.eol');
              if (eolElement) {
                // 以 .ans 為單位收集（每個 .ans 代表一行，不可分割）
                const ansElements = eolElement.querySelectorAll('.ans');
                if (ansElements.length > 0) {
                  // 如果有 .ans 元素，以 .ans 為單位
                  ansElements.forEach(ansEl => {
                    // 每個 .ans 作為一個不可分割的單元
                    nodes.push({ 
                      type: 'ans', 
                      content: ansEl.outerHTML,
                      element: ansEl.cloneNode(true)
                    });
                  });
                } else {
                  // 如果沒有 .ans 元素，收集其他子節點
                  Array.from(eolElement.childNodes).forEach(child => {
                    if (child.nodeType === Node.ELEMENT_NODE) {
                      nodes.push({ 
                        type: 'element', 
                        content: child.outerHTML,
                        element: child.cloneNode(true)
                      });
                    } else if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
                      nodes.push({ 
                        type: 'text', 
                        content: child.textContent
                      });
                    }
                  });
                }
              } else {
                // 如果沒有 .eol，收集所有子節點（排除 .imgBox）
                Array.from(ansBoxElement.childNodes).forEach(child => {
                  if (child.nodeType === Node.ELEMENT_NODE && child.classList && child.classList.contains('imgBox')) {
                    return;
                  }
                  if (child.nodeType === Node.ELEMENT_NODE) {
                    nodes.push({ 
                      type: 'element', 
                      content: child.outerHTML,
                      element: child.cloneNode(true)
                    });
                  } else if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
                    nodes.push({ 
                      type: 'text', 
                      content: child.textContent
                    });
                  }
                });
              }
              
              return nodes;
            };
            
            // 收集 ans_box 的內容節點
            const ansBoxClone = node.cloneNode(true);
            const imgBox = ansBoxClone.querySelector('.imgBox');
            const eolElement = ansBoxClone.querySelector('.eol');
            const contentNodes = collectAnsBoxContentNodes(ansBoxClone);
            
            // 將內容節點分頁（以 .ans 為單位）
            let currentPageAnsElements = [];
            const ansBoxPages = [];
            
            for (let i = 0; i < contentNodes.length; i++) {
              const contentNode = contentNodes[i];
              const testAnsElements = [...currentPageAnsElements, contentNode];
              
              // 構建測試用的 ans_box HTML
              let testAnsBoxHTML = '<div class="ans_box"';
              // 保留原始 ans_box 的屬性
              const originalAttrs = Array.from(node.attributes)
                .filter(attr => attr.name !== 'class')
                .map(attr => `${attr.name}="${attr.value}"`)
                .join(' ');
              if (originalAttrs) {
                testAnsBoxHTML += ` ${originalAttrs}`;
              }
              testAnsBoxHTML += '>';
              
              // 第一頁包含 .imgBox，後續頁不包含
              if (ansBoxPages.length === 0 && imgBox) {
                testAnsBoxHTML += imgBox.outerHTML;
              }
              
              // 構建 .eol 內容（包含所有 .ans 元素）
              if (eolElement) {
                const eolAttrs = Array.from(eolElement.attributes)
                  .map(attr => `${attr.name}="${attr.value}"`)
                  .join(' ');
                testAnsBoxHTML += `<div class="eol"${eolAttrs ? ' ' + eolAttrs : ''}>`;
                
                // 添加所有 .ans 元素
                testAnsElements.forEach(node => {
                  if (node.type === 'ans') {
                    testAnsBoxHTML += node.content;
                  } else if (node.type === 'element') {
                    testAnsBoxHTML += node.content;
                  } else if (node.type === 'text') {
                    testAnsBoxHTML += node.content;
                  }
                });
                
                testAnsBoxHTML += '</div>';
              } else {
                // 如果沒有 .eol，直接添加內容
                testAnsElements.forEach(node => {
                  if (node.type === 'element') {
                    testAnsBoxHTML += node.content;
                  } else if (node.type === 'text') {
                    testAnsBoxHTML += node.content;
                  }
                });
              }
              
              testAnsBoxHTML += '</div>';
              
              // 測量高度
              const testDiv = document.createElement('div');
              testDiv.className = 'content';
              testDiv.innerHTML = testAnsBoxHTML;
              
              // 修改：使用 setHTMLAndApplyBrStyles 方法
              if (measureContainer.setHTMLAndApplyBrStyles) {
                measureContainer.setHTMLAndApplyBrStyles(testDiv.outerHTML);
              } else {
                measureContainer.innerHTML = testDiv.outerHTML;
                const brElements = measureContainer.querySelectorAll('br');
                brElements.forEach(br => {
                  br.style.display = 'none';
                });
              }
              
              // 強制瀏覽器重排
              void measureContainer.offsetWidth;
              const testHeight = measureContainer.offsetHeight;
              
              if (testHeight > ansBoxMaxHeight + ansBoxTolerance && currentPageAnsElements.length > 0) {
                // 超過限制，保存當前頁並開始新頁
                ansBoxPages.push([...currentPageAnsElements]);
                currentPageAnsElements = [contentNode];
              } else {
                currentPageAnsElements.push(contentNode);
              }
            }
            
            // 保存最後一頁
            if (currentPageAnsElements.length > 0) {
              ansBoxPages.push(currentPageAnsElements);
            }
            
            // 創建多個 ans_box 頁面
            ansBoxPages.forEach((pageNodes, pageIndex) => {
              const ansBoxPageDiv = document.createElement('div');
              ansBoxPageDiv.className = 'content';
              
              const ansBoxDiv = document.createElement('div');
              ansBoxDiv.className = 'ans_box';
              // 複製原始 ans_box 的所有屬性
              Array.from(node.attributes).forEach(attr => {
                if (attr.name !== 'class') {
                  ansBoxDiv.setAttribute(attr.name, attr.value);
                }
              });
              
              // 第一頁包含 .imgBox
              if (pageIndex === 0 && imgBox) {
                ansBoxDiv.appendChild(imgBox.cloneNode(true));
              }
              
              // 添加 .eol 和內容
              if (eolElement) {
                const eolDiv = document.createElement('div');
                eolDiv.className = 'eol';
                // 複製原始 .eol 的所有屬性
                Array.from(eolElement.attributes).forEach(attr => {
                  eolDiv.setAttribute(attr.name, attr.value);
                });
                
                // 添加該頁的所有 .ans 元素（保持完整結構）
                pageNodes.forEach(node => {
                  if (node.type === 'ans') {
                    // 使用完整的 .ans 元素
                    eolDiv.appendChild(node.element.cloneNode(true));
                  } else if (node.type === 'element') {
                    eolDiv.appendChild(node.element.cloneNode(true));
                  } else if (node.type === 'text') {
                    eolDiv.appendChild(document.createTextNode(node.content));
                  }
                });
                
                ansBoxDiv.appendChild(eolDiv);
              } else {
                // 如果沒有 .eol，直接添加內容
                pageNodes.forEach(node => {
                  if (node.type === 'element') {
                    ansBoxDiv.appendChild(node.element.cloneNode(true));
                  } else if (node.type === 'text') {
                    ansBoxDiv.appendChild(document.createTextNode(node.content));
                  }
                });
              }
              
              ansBoxPageDiv.appendChild(ansBoxDiv);
              pages.push(ansBoxPageDiv.innerHTML);
            });
          } else {
            // ans_box 不超過 7 行：直接放到第二頁
            const secondPageDiv = document.createElement('div');
            secondPageDiv.className = 'content';
            // 使用 cloneNode(true) 保留 ans_box 的所有屬性和子節點
            secondPageDiv.appendChild(node.cloneNode(true));
            pages.push(secondPageDiv.innerHTML);
          }
          
          currentPageNodes = [];
        } else {
          // 未超過限制：保持原邏輯（subject + ans_box 一起）
          currentPageNodes = [];
          currentPageNodes.push(subjectNode.cloneNode(true));
          currentPageNodes.push(node.cloneNode(true));
        }
      } else {
        if (currentPageNodes.length > 0) {
          const pageDiv = document.createElement('div');
          pageDiv.className = 'content';
          currentPageNodes.forEach(n => pageDiv.appendChild(n.cloneNode(true)));
          pages.push(pageDiv.innerHTML);
        }
        
        currentPageNodes = [node.cloneNode(true)];
      }
    } else {
      currentPageNodes.push(node.cloneNode(true));
    }
  });
  
  if (currentPageNodes.length > 0) {
    const pageDiv = document.createElement('div');
    pageDiv.className = 'content';
    const measurementDiv = document.createElement('div');
    measurementDiv.className = 'content';
    currentPageNodes.forEach(n => {
      pageDiv.appendChild(n.cloneNode(true));
      measurementDiv.appendChild(cloneNodeForMeasurement(n));
    });
    pages.push(pageDiv.innerHTML);
    
    measureContainer.innerHTML = measurementDiv.outerHTML;
  }

  return pages;
};

/**
 * 處理 .content 結構的分頁邏輯
 */
export const handleContentStructure = (doc, contentElements, lineHeight, pageSize, measureContainer) => {
  let actualTotalPages = 0;
  const allImgSizeElements = doc.querySelectorAll('.imgSize');
  
  contentElements.forEach((contentElement, index) => {
    const internalImgSizeElements = [];
    const otherNodes = [];
    
    Array.from(contentElement.childNodes).forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
        return;
      }
      if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) {
        return;
      }
      
      if (node.nodeType === Node.ELEMENT_NODE && node.classList && node.classList.contains('imgSize')) {
        internalImgSizeElements.push(node);
      } else {
        otherNodes.push(node);
      }
    });
    
    let externalImgSizeCount = 0;
    let externalImgSizeActualHeight = 0;
    
    if (index === 0 && allImgSizeElements.length > 0) {
      const externalImgSizeElements = [];
      
      allImgSizeElements.forEach(imgSize => {
        const isInsideContent = contentElement.contains(imgSize);
        if (!isInsideContent) {
          const position = contentElement.compareDocumentPosition(imgSize);
          if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            externalImgSizeElements.push(imgSize);
          }
        }
      });
      
      externalImgSizeCount = externalImgSizeElements.length;
      
      if (externalImgSizeCount > 0) {
        // 修改：測量每個 .imgSize 元素的高度，取最大值
        let maxImgSizeHeight = 0;
        
        externalImgSizeElements.forEach(imgSize => {
          const imgSizeDiv = document.createElement('div');
          imgSizeDiv.className = 'content';
          imgSizeDiv.appendChild(imgSize.cloneNode(true));
          
          // 使用 setHTMLAndApplyBrStyles 方法
          if (measureContainer.setHTMLAndApplyBrStyles) {
            measureContainer.setHTMLAndApplyBrStyles(imgSizeDiv.outerHTML);
          } else {
            measureContainer.innerHTML = imgSizeDiv.outerHTML;
            const brElements = measureContainer.querySelectorAll('br');
            brElements.forEach(br => {
              br.style.display = 'none';
            });
          }
          
          // 強制瀏覽器重排
          void measureContainer.offsetWidth;
          
          // 測量 .imgSize 元素本身的高度（而不是 .content 容器）
          const imgSizeElement = measureContainer.querySelector('.imgSize');
          if (imgSizeElement) {
            const imgSizeHeight = imgSizeElement.offsetHeight;
            maxImgSizeHeight = Math.max(maxImgSizeHeight, imgSizeHeight);
          } else {
            // 如果找不到 .imgSize，使用容器高度
            const containerHeight = measureContainer.offsetHeight;
            maxImgSizeHeight = Math.max(maxImgSizeHeight, containerHeight);
          }
        });
        
        externalImgSizeActualHeight = maxImgSizeHeight;
      }
    }
    
    const internalImgSizeLines = internalImgSizeElements.length;
    
    let internalImgSizeActualHeight = 0;
    if (internalImgSizeElements.length > 0) {
      const imgSizeDiv = document.createElement('div');
      imgSizeDiv.className = 'content';
      internalImgSizeElements.forEach(imgSize => {
        imgSizeDiv.appendChild(imgSize.cloneNode(true));
      });
      measureContainer.innerHTML = imgSizeDiv.outerHTML;
      internalImgSizeActualHeight = measureContainer.offsetHeight;
    }
    
    let otherNodesHeight = 0;
    let otherNodesLines = 0;
    if (otherNodes.length > 0) {
      const otherNodesDiv = document.createElement('div');
      otherNodesDiv.className = 'content';
      otherNodes.forEach(node => {
        otherNodesDiv.appendChild(node.cloneNode(true));
      });
      measureContainer.innerHTML = otherNodesDiv.outerHTML;
      otherNodesHeight = measureContainer.offsetHeight;
      otherNodesLines = Math.ceil(otherNodesHeight / lineHeight);
    }
    
    const totalLines = internalImgSizeLines + otherNodesLines;
    const maxHeight = pageSize * lineHeight;
    const totalHeight = internalImgSizeActualHeight + otherNodesHeight;
    
    const tolerance = Math.max(maxHeight * 0.1, 1);
    const shouldPage = totalLines > pageSize || totalHeight >= (maxHeight - tolerance);

    if (shouldPage) {
      const allNodesForPaging = [...internalImgSizeElements, ...otherNodes];
      
      const pages = splitContentIntoPages(
        allNodesForPaging, 
        pageSize, 
        measureContainer, 
        lineHeight, 
        externalImgSizeCount,
        externalImgSizeActualHeight
      );
      
      if (pages.length > 1) {
        replaceContentElementWithPages(contentElement, pages, doc);
        actualTotalPages += pages.length;
      } else {
        actualTotalPages += 1;
      }
    } else {
      actualTotalPages += 1;
    }
  });
  
  if (actualTotalPages === 0) {
    actualTotalPages = 1;
  }
  
  return {
    htmlString: doc.body.innerHTML,
    totalPages: actualTotalPages,
  };
};

